var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.40967,
    y: 3.40723,
    width: 30.2362,
    height: 30.2362,
    fill: "url(#pattern0_496_6524)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_496_6524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 31,
    height: 31
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.40967,
    y: 3.40723,
    width: 30.2362,
    height: 30.2362,
    fill: "url(#pattern1_496_6524)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_496_6524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.40967,
    y: 3.40723,
    width: 30.2362,
    height: 30.2362,
    fill: "url(#paint0_linear_496_6524)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_496_6524",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_496_6524",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_496_6524",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_496_6524",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_496_6524",
    x1: 2.40967,
    y1: 18.5253,
    x2: 32.6459,
    y2: 18.5253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_496_6524",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHeart);
export default __webpack_public_path__ + "static/media/likeHeart.65c54e5223eb1acfc38c17b63f990d38.svg";
export { ForwardRef as ReactComponent };